<template>
    <div class="mt-40 bg-camaq-700 text-white lg:p-0">
        <div class="container mx-auto grid lg:grid-cols-2">
            <div>
                <div class="mt-6 xl:mt-12">
                    <p class="text-sm font-bold uppercase tracking-wider">{{ $t('Support available at all times') }}</p>
                    <p class="mt-6 text-6xl font-semibold">{{ $t('A team attentive to your needs') }}</p>
                    <p class="mt-3 max-w-[600px]">
                        {{ $t('You can count on a team of dedicated professionals to support your company.') }}
                    </p>
                </div>

                <div class="mt-12 flex items-center space-x-8 py-4">
                    <InertiaLink
                        href="/contact"
                        class="inline-flex rounded-lg bg-primary py-3 px-6 text-sm font-bold uppercase tracking-wider text-white hover:bg-opacity-90"
                    >
                        {{ $t('Contact us') }}
                    </InertiaLink>

                    <a
                        href="tel:14504034300"
                        class="inline-flex rounded-lg border-2 border-white py-3 px-6 text-sm font-bold uppercase tracking-wide hover:bg-white hover:text-primary"
                    >
                        1-450-403-4300
                    </a>
                </div>
            </div>

            <img src="/images/home_2.jpg" alt="" class="hidden h-full max-h-[400px] w-full object-cover lg:block" />
        </div>
    </div>
</template>

<script setup></script>
